import $ from 'jquery'; window.$ = $; window.jQuery = $;
import { gsap } from 'gsap';
import { initMechanika } from './src/mechanika.js';
import { initSoundUnlock } from './src/audio.soundsFx.js';
// import { initPlayerControl } from './src/audio.player.js';

import { AudioPlayer } from './src/audio.player.js';

import { initMenu, initMenuBlackSection } from './src/menu.js';
/* import { initPhones } from './src/portfolio.phones.js'; */
import { initComicsDialogs } from './src/komisy.dialogi.js';
import { initComicsNavigations } from './src/komiksy.nawigacja.js';
import { initTextResolverAnimation } from './src/letteranimation.js';
import { initCursorGlow } from './src/inside.cursorGlow.js';
import { initDustAnimation } from './src/inside.dustAnimation.js';
import { initPaperWave } from './src/paperWave.js';
/* import { initPortfolioCaseStudy } from './src/portfolio.caseStudy.js'; */
import { initPoziomice } from './src/perlin.poziomice.js';
import { Bubble } from './lib/comical-wrapper.js';
import { initMagnetic } from './lib/cursor.init.js';
import { initCursor } from './lib/cursor.js';
import { initMyszeczki } from './src/myszeczka.js';
import { initListAnimations } from './src/oferta.animationList.js';



window.addEventListener('DOMContentLoaded', () => {
  // PACZKA 1 – rzeczy krytyczne (ładowane natychmiast)
  initMechanika();
  initMenu();
  initMenuBlackSection();

  // PACZKA 2 – rzeczy lekkie, ale potrzebne od razu (np. audio, player)
  requestAnimationFrame(() => {
    initSoundUnlock();
    // initPlayerControl();

    // Inicjalizacja dla wszystkich playerów na stronie
    document.querySelectorAll('.playeros').forEach(container => new AudioPlayer(container));


  });

  // PACZKA 3 – rzeczy lekkie, które nie muszą być natychmiast
  requestAnimationFrame(() => {
    initComicsDialogs();
    initComicsNavigations();
    initTextResolverAnimation('[data-resolver-first]');
    // puenta: literkowanie dopiero, gdy napis dojedzie scrollem do docelowej pozycji
    initTextResolverAnimation('[data-resolver-second]', { scrollContainer: '.sticky-content', settleTarget: '.facetos-content', threshold: 0.1 });
  });

  // --- 💤 Lazy init (sekcje ciężkie graficznie) ---
  initWhenVisible('#canvas-1', () => initPaperWave('#canvas-1', { reveal: '.noir-enter-image' }));
  initWhenVisible('#section2b', () => {
    initDustAnimation('#section2b');
    initCursorGlow('#section2b');
  });

  // PACZKA 4 – reszta, mniej krytyczne efekty
  requestAnimationFrame(() => {
    initPoziomice();
    initMagnetic();
    initCursor();
    initMyszeczki();
    initListAnimations();
  });
});


// ---------------------
// Lazy init helper
// ---------------------
function initWhenVisible(selector, callback) {
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        callback();
        observer.disconnect();
      }
    });
  });
  document.querySelectorAll(selector).forEach(el => observer.observe(el));
}